// 业务地区静态数据（替代远程接口获取）
const businessAreaData = [
  {
    "AreaName": "深圳市",
    "CreatorName": "医+E管理",
    "BA_ID": "0ff4f013-0b71-4625-a358-7c3542ee9a78",
    "BA_AreaCode": "e2e499fd-48eb-40df-ab76-ef3b19b14fa4",
    "BA_Title": "深圳市医师定期考核在线学习课程",
    "BA_Subtitle": "深圳市医师定期考核在线学习课程",
    "BA_ImgPath": "https://cdn.doc-exam.com/Images/epluse-dk-area/76311d12-e38d-4492-900e-bf56c1dabb53.jpg",
    "BA_StatusCode": 1001,
    "BA_Remark": "\r\n<div> <image  src=\"https://cdn.doc-exam.com/cms/1pluse/tupian.png\" /></div>\r\n\r\n<style>\r\n.courseShowList {\r\n    margin: -80px auto;\r\n \r\n    border: 0 solid #000;\r\n    width: 60%;\r\n    text-align: left\r\n}\r\n</style>\r\n",
    "BA_CreateDate": "2020-09-16",
    "BA_Creator": "2a25ed5e-a6b7-4fb7-af05-0019d59190eb",
    "BA_UpateDate": "2026-01-06",
    "BA_Modifier": "2a25ed5e-a6b7-4fb7-af05-0019d59190eb"
  },
  {
    "AreaName": "惠州市",
    "CreatorName": "医+E管理",
    "BA_ID": "55174c07-6775-411e-a8e5-c2740ae416c5",
    "BA_AreaCode": "87bb64be-a958-4605-a568-301c9fcc38e7",
    "BA_Title": "惠城、仲恺区医师定期考核在线学习",
    "BA_Subtitle": "惠城、仲恺区医师定期考核在线学习",
    "BA_ImgPath": "https://cdn.doc-exam.com/Images/epluse-dk-area/7fa5a65c-ee46-4ed1-829c-c2ec574f4cf1.jpg",
    "BA_StatusCode": 1001,
    "BA_Remark": "\r\n<div> <image  src=\"https://cdn.doc-exam.com/cms/1pluse/tupian.png\" /></div>\r\n\r\n<style>\r\n.courseShowList {\r\n    margin: -80px auto;\r\n \r\n    border: 0 solid #000;\r\n    width: 60%;\r\n    text-align: left\r\n}\r\n</style>\r\n",
    "BA_CreateDate": "2019-10-15",
    "BA_Creator": "2a25ed5e-a6b7-4fb7-af05-0019d59190eb",
    "BA_UpateDate": "2026-01-08",
    "BA_Modifier": "2a25ed5e-a6b7-4fb7-af05-0019d59190eb"
  },
  {
    "AreaName": "内蒙古自治区",
    "CreatorName": "医+E管理",
    "BA_ID": "8d476152-216b-4a60-8515-17adbf61fc6d",
    "BA_AreaCode": "c0364fe6-c329-4d44-9838-bc0568383418",
    "BA_Title": "内蒙古医师定期考核在线学习课程",
    "BA_Subtitle": "内蒙古医师定期考核在线学习课程",
    "BA_ImgPath": "https://cdn.doc-exam.com/Images/epluse-dk-area/5b0df7a1-fef4-40d8-9e80-47688dbe3add.jpg",
    "BA_StatusCode": 1001,
    "BA_Remark": "<div> <image src=\"https://cdn.doc-exam.com/cms/cnmia/Content/Upload/image/20231106/6383485918048460049221073.png\" /></div>\r\n\r\n<style>\r\n.courseShowList {\r\n    margin: -70px auto;\r\n \r\n    border: 0 solid #000;\r\n    width: 60%;\r\n    text-align: left\r\n}\r\n</style>\r\n",
    "BA_CreateDate": "2019-10-15",
    "BA_Creator": "2a25ed5e-a6b7-4fb7-af05-0019d59190eb",
    "BA_UpateDate": "2026-01-06",
    "BA_Modifier": "2a25ed5e-a6b7-4fb7-af05-0019d59190eb"
  },
  {
    "AreaName": "珠海市",
    "CreatorName": "医+E管理",
    "BA_ID": "91751d3b-5fa7-49b6-bb6f-101a8a2ce9e7",
    "BA_AreaCode": "8a10dba6-7805-4684-aa64-7084ba097fba",
    "BA_Title": "珠海市医师定期考核在线学习课程",
    "BA_Subtitle": "珠海市医师定期考核在线学习课程",
    "BA_ImgPath": "https://cdn.doc-exam.com/Images/epluse-dk-area/e16d2387-bc7c-4e35-8cb4-bedd84f9a980.jpg",
    "BA_StatusCode": 1001,
    "BA_Remark": "\r\n<div> <image  src=\"https://cdn.doc-exam.com/cms/1pluse/tupian.png\" /><br><br></div>\r\n\r\n<style>\r\n.courseShowList {\r\n    margin: -58px auto;\r\n \r\n    border: 0 solid #000;\r\n    width: 60%;\r\n    text-align: left\r\n}\r\n</style>\r\n",
    "BA_CreateDate": "2019-10-15",
    "BA_Creator": "2a25ed5e-a6b7-4fb7-af05-0019d59190eb",
    "BA_UpateDate": "2026-01-06",
    "BA_Modifier": "2a25ed5e-a6b7-4fb7-af05-0019d59190eb"
  },
  {
    "AreaName": "东莞市",
    "CreatorName": "医+E管理",
    "BA_ID": "d2f9e081-c20a-4b75-88b6-8c6be27760e4",
    "BA_AreaCode": "125e8739-531a-4cfa-bba8-71fa0fffb0f3",
    "BA_Title": "东莞市医师定期考核在线学习课程",
    "BA_Subtitle": "东莞市医师定期考核在线学习课程",
    "BA_ImgPath": "https://cdn.doc-exam.com/Images/epluse-dk-area/367ca7a1-5021-4eaf-b04b-6c1ac81cf641.jpg",
    "BA_StatusCode": 1001,
    "BA_Remark": "<div> <image src=\"https://cdn.doc-exam.com/cms/cnmia/Content/Upload/image/20231106/6383485918048460049221073.png\" /></div>\r\n\r\n<style>\r\n.courseShowList {\r\n    margin: -70px auto;\r\n \r\n    border: 0 solid #000;\r\n    width: 60%;\r\n    text-align: left\r\n}\r\n</style>\r\n",
    "BA_CreateDate": "2019-10-15",
    "BA_Creator": "2a25ed5e-a6b7-4fb7-af05-0019d59190eb",
    "BA_UpateDate": "2026-01-06",
    "BA_Modifier": "2a25ed5e-a6b7-4fb7-af05-0019d59190eb"
  }
]

export default businessAreaData
